export enum BINNDING_STAGES {
	PERMISSIONS_STATUS = 'PERMISSIONS_STATUS',
	MOBILE_VERIFICATION_STATUS = 'MOBILE_VERIFICATION_STATUS',
	DEVICE_BINDING_INIT = 'DEVICE_BINDING_INIT',
	DEVICE_BINDING_STATUS = 'DEVICE_BINDING_STATUS',
}
